import * as React from 'react';
const SvgTag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M13.443 3c-.29 0-.58.07-.84.2-.3.14-.55.39-1.05.89l-7.136 7.135c-.78.78-1.17 1.17-1.32 1.62-.13.4-.13.82 0 1.219.15.45.54.84 1.32 1.619l3.898 3.898c.78.78 1.17 1.17 1.62 1.32.2.059.4.099.61.099s.41-.03.61-.1c.449-.15.839-.54 1.618-1.32l7.137-7.135c.5-.5.75-.75.89-1.05.13-.26.2-.55.2-.84 0-.329-.11-.669-.33-1.338l-.73-2.18c-.27-.819-.41-1.229-.64-1.568-.21-.3-.47-.56-.769-.77-.34-.23-.75-.37-1.57-.64l-2.178-.73c-.66-.22-1-.329-1.32-.329zm-2.909 15.951c-.19-.16-.5-.48-.81-.79l-3.898-3.897c-.31-.31-.63-.63-.79-.81.16-.19.48-.5.79-.81l7.137-7.135c.19-.18.39-.39.51-.49.15.04.42.13.67.21l2.179.73c.52.17.97.32 1.08.4.1.07.18.149.25.249.08.11.22.56.4 1.08l.729 2.178c.09.26.18.53.21.67-.1.11-.3.31-.49.5l-7.137 7.136c-.31.31-.63.63-.81.79z"
    />
    <path
      fill="currentColor"
      d="M14.993 7.997c-.28 0-.52.1-.71.29s-.29.43-.29.71a.99.99 0 0 0 1 1c.28 0 .52-.1.71-.29s.29-.43.29-.71-.09-.52-.29-.71a.97.97 0 0 0-.71-.29"
    />
  </svg>
);
export default SvgTag;
